// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMobileAppThemeDto
 */
export interface IMobileAppThemeDto {
    /**
     * 
     * @type {number}
     * @memberof IMobileAppThemeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppThemeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppThemeDto
     */
    main_color?: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppThemeDto
     */
    color_schema_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppThemeDto
     */
    logotype_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppThemeDto
     */
    illustration_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppThemeDto
     */
    card_illustration_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IMobileAppThemeDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IMobileAppThemeDto
     */
    organization_id?: number;
}

/**
 * Check if a given object implements the IMobileAppThemeDto interface.
 */
export function instanceOfIMobileAppThemeDto(value: object): value is IMobileAppThemeDto {
    return true;
}

export function IMobileAppThemeDtoFromJSON(json: any): IMobileAppThemeDto {
    return IMobileAppThemeDtoFromJSONTyped(json, false);
}

export function IMobileAppThemeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMobileAppThemeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'main_color': json['main_color'] == null ? undefined : json['main_color'],
        'color_schema_link': json['color_schema_link'] == null ? undefined : json['color_schema_link'],
        'logotype_link': json['logotype_link'] == null ? undefined : json['logotype_link'],
        'illustration_link': json['illustration_link'] == null ? undefined : json['illustration_link'],
        'card_illustration_link': json['card_illustration_link'] == null ? undefined : json['card_illustration_link'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
    };
}

export function IMobileAppThemeDtoToJSON(json: any): IMobileAppThemeDto {
    return IMobileAppThemeDtoToJSONTyped(json, false);
}

export function IMobileAppThemeDtoToJSONTyped(value?: IMobileAppThemeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'main_color': value['main_color'],
        'color_schema_link': value['color_schema_link'],
        'logotype_link': value['logotype_link'],
        'illustration_link': value['illustration_link'],
        'card_illustration_link': value['card_illustration_link'],
        'organization_path': value['organization_path'],
        'organization_id': value['organization_id'],
    };
}

